var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#183238",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.667 7.778v2.37c0 .655-.531 1.185-1.186 1.185H1.185c-.654 0-1.185-.53-1.185-1.185v-2.37",
    transform: "translate(-1171 -111) translate(1171 107) translate(0 4) translate(2.667 2)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.926 2.963L2.963 0 0 2.963",
    transform: "translate(-1171 -111) translate(1171 107) translate(0 4) translate(2.667 2) matrix(1 0 0 -1 2.37 8.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.963 1.185L2.963 8.296",
    transform: "translate(-1171 -111) translate(1171 107) translate(0 4) translate(2.667 2) matrix(1 0 0 -1 2.37 8.667)"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDarkIcon);
export default __webpack_public_path__ + "static/media/downloadDarkIcon.fe19f07563a6812820320e1ef06c464b.svg";
export { ForwardRef as ReactComponent };